import type { IUserService } from "./IUserService";
import type { ApiReturnUser, ApiUser, ApiUserUpdateDTO } from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";


class UserService implements IUserService {
    // get(): Promise<ApiReturnUser[]> {
    //     throw new Error("Method not implemented.");
    // }

    async getUsersByProjectId(projectId: number): Promise<ApiReturnUser[]> {
        const response = await api_config.get(`/projects/${projectId}/users`);
        return response.data;
    }

    async getUsersBySiteId(siteId: number): Promise<ApiReturnUser[]> {
        const response = await api_config.get(`/sites/${siteId}/users`);
        return response.data;
    }

    // get(id: number): Promise<ApiReturnUser> {
    //     throw new Error("Method not implemented.");
    // }
    async add(params: ApiUser): Promise<ApiReturnUser> {
        const response = await api_config.post('/users-highimpact', params);
        return response.data;
    }

    /**
     * Ideally, we should not use a password in ApiReturnUser. 
     * According to the project concept, we only set a password when creating a user,
     * and then the user manages the password from their personal account, 
     * and we do not have access to it. 
     * There is no point in transferring sensitive data back and forth.
     */
    async update(id: number, params: ApiUserUpdateDTO): Promise<ApiReturnUser> {
        const response = await api_config.put(`/users-highimpact/${id}`, params);
        return response.data
    }

    async delete(id: number): Promise<ApiReturnUser> {
        const response = await api_config.delete(`/users-highimpact/${id}`);
        return response.data;
    }
}

const userServiceInstance = new UserService();
export default userServiceInstance;